if (!customElements.get('widgets-slider')) {
  class WidgetsSlider extends HTMLElement {
    selectors = {
      swiper: '.swiper',
      scrollbar: '.swiper-scrollbar',
    };
    settings = {
      slidesPerView: 1.12,
      spaceBetween: 16,
      scrollbar: {
        el: this.selectors.scrollbar,
      },
      breakpoints: {
        768: {
          slidesPerView: 2.5,
          spaceBetween: 24,
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 24,
        },
      },
    };
    slider = undefined;

    /**
     * Constructor.
     */
    constructor() {
      super();
    }

    /**
     * Connected callback.
     */
    connectedCallback() {
      this.init();
    }

    /**
     * Init.
     *
     * @returns {Void}
     */
    init() {
      const swiper = this.querySelector(this.selectors.swiper);
      if (!swiper) return;

      this.slider = new Swiper(swiper, this.settings);
    }
  }
  customElements.define('widgets-slider', WidgetsSlider);
}
